module.exports = __webpack_public_path__ + "img/jkgl.dc639057.png";